import { useQuery } from '../models/reactUtils'
import {
  APILoadingStatus,
  Map,
  useApiIsLoaded,
  useApiLoadingStatus,
  useMap,
} from '@vis.gl/react-google-maps'
import { observer } from 'mobx-react'
import React, { Suspense, useEffect } from 'react'

import { useTheme } from '@mui/material/styles'

import { GOOGLE_MAPS_ID } from '../constants'
import { logger } from '../utils/logger'
import LanguageSelect from './LanguageSelect'
import MapClusteredLocationMarkers from './MapClusteredLocationMarkers'
import MapLoader from './MapLoader'
import SearchThisAreaButton from './SearchThisAreaButton'

const MapContainer = observer(({ toggleDrawer }) => {
  const { store } = useQuery()
  const theme = useTheme()
  const isApiLoaded = useApiIsLoaded()
  const status = useApiLoadingStatus()
  const map = useMap()
  const locations = store.locationStore.activeSearchResultLocations
  const loading = store.loading

  useEffect(() => {
    if (status === APILoadingStatus.FAILED) {
      logger.error(status)
    }
  }, [status])

  useEffect(() => {
    if (map && store.boundingBox) {
      map.fitBounds(store.boundingBox)
    }
  }, [map, store.boundingBox])

  if (!isApiLoaded) {
    return <MapLoader message={'Loading Map...'} />
  }

  return (
    <Map
      mapId={GOOGLE_MAPS_ID}
      defaultCenter={{ lat: 39.8283, lng: -98.5795 }}
      disableDefaultUI={true}
      zoomControl={true}
      defaultZoom={4}
    >
      <Suspense fallback={<MapLoader message={'Loading Translations...'} />}>
        <LanguageSelect />
      </Suspense>
      <SearchThisAreaButton />
      {loading ? (
        <MapLoader message={'Loading Locations...'} />
      ) : (
        <MapClusteredLocationMarkers
          locations={locations}
          store={store}
          toggleDrawer={toggleDrawer}
          theme={theme}
        />
      )}
    </Map>
  )
})

MapContainer.displayName = 'MapContainer'
export default MapContainer
